import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  ratingList: [],
  avgRating: 0,
  totalReviews: 0,
  processing: false,
};

const getInstructorReviewSummarySlice = createSlice({
  name: "getInstructorReviewSummary",
  initialState,
  reducers: {
    pending() {
      return {
        ...initialState,
        processing: true,
      };
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      /* TODO: reducer for success*/
      return { ...state, ...action.payload, processing: false };
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getInstructorReviewSummarySlice;
const getInstructorReviewSummaryAction = createAction(name);

export {
  getInstructorReviewSummaryAction,
  actions as getInstructorReviewSummaryActions,
  reducer as getInstructorReviewSummaryReducer,
};
